module.exports = __webpack_public_path__ + "0e081c2ca2e5805c7cdc5640710f7a18.pdf";